import Api from '@/api/Api'
import store from '../store'

export default {

  async getStock (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('stock', { params }))
  },

  async getStocksBySkus (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('stocks-by-skus', { params }))
  },

  async updateStock (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('stock', data, options))
  },

  async updateStockTransfer (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('stock/transfer', data, options))
  },

  async updateStockWarning (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('stock/warning', data, options))
  },

  async updateStockBin (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('stock/bin', data, options))
  },

  async getActivities (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('stock/activities', { params }))
  },

  async getTodo () {
    return store.dispatch('checkResponseApi', await Api().get('stock/todo'))
  },

  async getCurrentstocks (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('stock/current', { params }))
  },

  async getSkuLevel (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('inventory/skus-level', { params }))
  },

  async getUsedLotSerialSkus () {
    return store.dispatch('checkResponseApi', await Api().get('inventory/used-lot-serial/skus'))
  },

}



// WEBPACK FOOTER //
// ./src/api/StockService.js